<script setup>
import {computed, ref, watch} from 'vue'
import FormPageContentField from "@/common/form/FormPageContentField.vue"
import ContentUsageCount from "@/common/ContentUsageCount.vue"
import Button from '@/common/Button.vue'
import api from '@/services/api'
import {usePageContentDataStore} from '@/stores/pageContentData'
import {useModalsStore} from '@/stores/modals'
import {useItemDataStore} from '@/stores/itemData'
import {useRoute, useRouter} from "vue-router"

const props = defineProps({
    pageContentDataItem: Object,
    lastContentArea: String
})

const router = useRouter()
const route = useRoute()

const pageContentDataStore = usePageContentDataStore()
const modalsStore = useModalsStore()
const itemDataStore = useItemDataStore()

const contentId = computed(() => props.pageContentDataItem.contentId)

const isSiteTree = computed(() => route.name === 'siteTree')

const item = ref(null)

watch(
    contentId,
    async (newId) => {
        if (!newId) {
            item.value = null
            return
        }
        item.value = await itemDataStore.get({
            tableName: 'content',
            id: newId
        })
    },
    {immediate: true}
)

const goToContent = () => {
    isSiteTree.value
        ? router.push({
            name: 'siteTree',
            params: {
                pageOrContentId: 'c' + props.pageContentDataItem.id
            }
        })
        : router.push({
            name: 'form',
            params: {
                component: 'content',
                id: props.pageContentDataItem.contentId
            }
        })
}

const moveUp = async () => {
    let items = pageContentDataStore.items.filter((obj) => {
        return (
            obj.pageId === props.pageContentDataItem.pageId &&
            obj.contentArea === props.lastContentArea
        )
    })
    let newDisplayOrder = items.length + 1

    try {
        await api.post('api/move-page-content', {
            pageContentLinkId: props.pageContentDataItem.id,
            contentArea: props.lastContentArea,
            displayOrder: newDisplayOrder
        })
        await pageContentDataStore.init()
    } catch (err) {
        // Handle error if needed
    }
}

const removeContent = () => {
    modalsStore.show({
        componentName: 'ConfirmModal',
        obj: {
            modalTitle: 'Are you sure?',
            onConfirm: async () => {
                try {
                    await api.delete(`api/delete-page-content-link-id/${props.pageContentDataItem.id}`)
                    await pageContentDataStore.init()
                } catch (err) {
                    // Handle error if needed
                }
            }
        }
    })
}
</script>

<template>
    <div class="list-group-item py-1 pe-2 d-flex align-items-center">
        <div class="flex-fill">
            <FormPageContentField :content-id="contentId"/>
        </div>

        <ContentUsageCount :page-content-id="pageContentDataItem.id" :show-menu="true" class="me-2 lh-1"/>

        <Button class="btn-sm" @click="goToContent"><i class="bi-pencil-square"/></Button>
        <Button class="btn-sm" @click.prevent.stop="moveUp"><i class="bi-chevron-up"/></Button>
        <Button class="btn-sm" @click="removeContent"><i class="bi-x-lg"/></Button>
    </div>
</template>